import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Download from '../components/Download';
import Company from '../components/Company';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-white text-ink overflow-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Download />
        <Company />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
